module.exports = __webpack_public_path__ + "img/com.codeway.chatap-staging.37a6664d.png";